// Import Dependencies
import PropTypes from "prop-types";

// Local Imports
import { useDisclosure, useDidUpdate, useIsomorphicEffect } from "hooks";
import { useBreakpointsContext } from "../breakpoint/context";
import { SidebarContext } from "./context";
import { useState } from "react";

const initialState = {
  isExpanded: false,
  setIsExpanded: () => {},
};

export function SidebarProvider({ children }) {
  const { xlAndUp, lgAndDown, name } = useBreakpointsContext();

  const [isHovered, setHovered] = useState(false);
  const [isPinned, setPinned] = useState(false);

  const isExpanded = isPinned || isHovered;

  const toggle = () => setPinned((prev) => !prev);
  const open = () => {
    if (lgAndDown) {
      setPinned(true);
    }
  };
  const close = (force = false) => {
    setPinned(false);
    if (force) {
      setHovered(false);
    }
  };

  // Close Sidebar when Breakpoint changed
  useDidUpdate(() => {
    lgAndDown && close();
  }, [name]);

  useIsomorphicEffect(() => {
    const documentBody = document?.body;
    if (documentBody) {
      if (isPinned) {
        documentBody.classList.add("is-sidebar-open");
      } else {
        documentBody.classList.remove("is-sidebar-open");
      }

      if (isExpanded) {
        documentBody.classList.add("is-sidebar-expanded");
      } else {
        documentBody.classList.remove("is-sidebar-expanded");
      }
    }
  }, [isPinned, isExpanded]);

  if (!children) {
    return;
  }

  return (
    <SidebarContext
      value={{
        isExpanded,
        isHovered,
        setHovered,
        isPinned,
        setPinned,
        toggle,
        open,
        close,
      }}
    >
      {children}
    </SidebarContext>
  );
}


SidebarProvider.propTypes = {
  children: PropTypes.node,
};
